import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUpload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 18,
	viewBox: "0 0 19 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Upload" }), /* @__PURE__ */ _jsx("path", {
		d: "M6.16663 12.3333L9.49996 9M9.49996 9L12.8333 12.3333M9.49996 9V16.5M16.1666 12.9524C17.1845 12.1117 17.8333 10.8399 17.8333 9.41667C17.8333 6.88536 15.7813 4.83333 13.25 4.83333C13.0679 4.83333 12.8975 4.73833 12.8051 4.58145C11.7183 2.73736 9.71199 1.5 7.41663 1.5C3.96485 1.5 1.16663 4.29822 1.16663 7.75C1.16663 9.47175 1.86283 11.0309 2.98908 12.1613",
		stroke: "#344054",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgUpload;
